<script>
	export let data

    import PageLoader from '../components/PageLoader.svelte'
	import Main from '../components/Main.svelte'

	import SectionHome from '../components/Sections/SectionHome.svelte'
    import SectionText from '../components/Sections/SectionText.svelte'
    import SectionFeature from '../components/Sections/SectionFeature.svelte'
    import SectionContact from '../components/Sections/SectionContact.svelte'
	import SectionNewsletter from '../components/Sections/SectionNewsletter.svelte';
	import SectionSteps from '../components/Sections/SectionSteps.svelte';
	import SectionVideoFeature from '../components/Sections/SectionVideoFeature.svelte';
	import SectionCards from '../components/Sections/SectionCards.svelte';

	const title = data.title
	const sections = data.sections
	const isLandingPage = data.landingpage

	const sectionTypes = {
		HOME: 'sections.home',
		TEXT: 'sections.text',
		FEATURE: 'sections.feature',
		CONTACT: 'sections.contact',
		NEWSLETTER: 'sections.newsletter',
		GRID: 'sections.grid',
		STEPS: 'sections.steps',
		VIDEOFEATURE: 'sections.video-feature'
	}

</script>

<svelte:head>
	{#if isLandingPage}
    <title>Global Shipping Watch</title>
	{:else}
	<title>{title} - Global Shipping Watch</title>
	{/if}
</svelte:head>

<Main>
	{#each sections as section}
		{#if section.__component === sectionTypes.HOME}
			<SectionHome content={section} />
		{:else if section.__component === sectionTypes.TEXT}
			<SectionText content={section} />
		{:else if section.__component === sectionTypes.FEATURE}
			<SectionFeature content={section} />
		{:else if section.__component === sectionTypes.CONTACT}
			<SectionContact content={section} />
		{:else if section.__component === sectionTypes.NEWSLETTER}
			<SectionNewsletter content={section} />
		{:else if section.__component === sectionTypes.STEPS}
			<SectionSteps content={section} />
		{:else if section.__component === sectionTypes.VIDEOFEATURE}
			<SectionVideoFeature content={section} />
		{:else if section.__component === sectionTypes.GRID}
			<SectionCards data={section} />
		{/if}
	{/each}
</Main>